import Phaser from 'phaser'

import { Bathroom, Bathroomv2, Bathroomv3 } from './scenes/bathroom/bathroom.scene'
import { Bedroom, Bedroomv2, Bedroomv3 } from './scenes/bedroom/bedroom.scene'
//import { ParkScene } from './scenes/park/park.scene'

const random = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 *  get stored scenes
 */
const STORED_SCENES = {
  KEY: "$app-STORED-SCENES",
  get: function () { return (localStorage.getItem(this.KEY) || "").trim().split(",") },
  add: function (scene_key) {
    let stored = this.get();
    if (stored.indexOf(scene_key) === -1) {
      stored.push(scene_key);
      localStorage.setItem(this.KEY, stored.join(","));
    }

  },
  clear: function () {
    localStorage.setItem(this.KEY, "");
  },
  has: function (scene_key) {
    return this.get().indexOf(scene_key) > -1;
  }
};
export default class PhaserGame {
  DIMENTIONS
  CONFIG
  GAME
  HANDLE_PUSH_DATA

  PARENT_ID
  RUNNING = false
  SCENES = [Bedroom, Bedroomv2, Bedroomv3, Bathroom, Bathroomv2, Bathroomv3]
  SCENES_KEYS = [
    "bedroom",
    "bedroomv2",
    "bedroomv3",
    "bathroom",
    "bathroomv2",
    "bathroomv3"
  ]
  /**
   *
   * @param {string} initialScene key string for initial scene - default `park`
   * @param {string} parentID #id-container for render Phaser - default `phaser-game`
   * @param {Function} handlePushData handle for push data events 
   */

  constructor(

    parentID = 'phaser-game',
    handlePushData = () => {
      console.info('Empty handle push data!!')
    }
  ) {
    this.isMobile = window.innerWidth < 1024

    this.PARENT_ID = parentID
    this.HANDLE_PUSH_DATA = handlePushData
    this.DIMENTIONS = {
      X: Math.min(window.innerWidth, 1300),//1400
      Y: Math.min(window.innerHeight, 600),//900
    }
    this.isFullScreen = false;

    this.CONFIG = {
      type: Phaser.AUTO,
      width: this.DIMENTIONS.X,
      height: this.DIMENTIONS.Y,
      parent: this.PARENT_ID, 
      scene: [{ preload: this.preload }, ...this.SCENES],
    }

    this.currentScenekey = null;

    // -- this.init();
   // -- window.$gc = this;
    // -- console.log("%cINITIANDO...","font-size:32px;color:blue")

  }

  init() {
    if (!this.GAME) {
      this.GAME = new Phaser.Game({ ...this.CONFIG })
      sessionStorage.setItem('PHASER_RUNNING', 'false')
    }
  }

  preload() {
    // --  console.info('%cPhaserGame preload',"font-size:24px;color:blue;")
    this.load.script('webfont', 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js');
  }

  start(sceneKey) {
    try {

      if (!this.RUNNING) {

        // --console.info('PhaserGame START', sceneKey)
        this.GAME.scene.start(sceneKey, {
          handleEndScene: data => {
            // STORE THE SCENE PLAYED
            STORED_SCENES.add(this.currentScenekey);
            //..
            this.handleEndScene(data)
          },
          mediaType: this.isMobile ? 'mobile' : 'desktop',
        })
        this.currentScenekey = (sceneKey);
      } else {
        throw new Error('Game is already start')
      }
    } catch (error) {
      console.error(error)
    }
  }


  resume(keyScene) {
    // -- console.info('%cPhaserGame Resume', "font-size:24px;color:blue;")
    this.init();
    sessionStorage.setItem('PHASER_RUNNING', 'true')
    this.GAME.scene.resume(keyScene)
  }

  handleEndScene(dataEndGame) {
    this.HANDLE_PUSH_DATA(dataEndGame, this.handleNextScene)
  }

  handleNextScene(__sceneKey) {
    // this.GAME.scene.start(__sceneKey, { handleEndScene: this.handleEndScene })
  }
  addPoints(points) {
    const currentScene = this.GAME.scene.getScene(this.currentScenekey);
    currentScene.data.set('POINTS', points);
  }


  getRandomScene() {
    // - return "bathroomv2";
    // THE IDEA HERE IS TO PREVENT THIS PLAYER TO REPLAY SAME SCENARIO
    //  WHEN THE PLAYER  BEAT ALL 6 SCENARIOS IT WILL CLEAR ALL SAVED SCENARIOS TO RE PLAY 
    let storedScenes = STORED_SCENES.get();
    let avaibleScenes = this.SCENES_KEYS
      .filter((key) => {
        return storedScenes.indexOf(key) == -1
      });
    const totalScenes = avaibleScenes.length;
    // console.log("%cstoredScenes ", "font-size:24px; color:green;", storedScenes, "avaibleScenes: ", avaibleScenes);
    if (totalScenes === 0) {
      STORED_SCENES.clear();
      return this.getRandomScene();
    }
    let rndIdx = random(0, totalScenes - 1);
    let rndScene = avaibleScenes[rndIdx];
    // console.log("%crndScene: ", "font-size:24px; color:green;", rndScene, rndIdx,avaibleScenes);

    return rndScene;
  }
  destroy() {
    if (this.GAME) {
      this.GAME.scene.stop();
      this.GAME.destroy(true);
      this.GAME = null;
      this.RUNNING = false;
    }
  }
}
